/**
 * Mannat Couture - Launch Promotions & Luxury Offer Discovery Logic
 * 1. 1-Click Clipboard Coupon Copying
 * 2. Timed Welcome Privilege Modal with Session Memory
 * 3. Client-Side Collection Sorting by Highest Discount Percentage
 */

(function () {
  'use strict';

  /* -------------------------------------------------------------------------
   * Helper: Copy text to clipboard with fallback
   * ------------------------------------------------------------------------- */
  function copyTextToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) resolve();
        else reject(new Error('copy command failed'));
      } catch (err) {
        document.body.removeChild(textArea);
        reject(err);
      }
    });
  }

  /* -------------------------------------------------------------------------
   * 1. 1-Click Clipboard Copy Handler
   * ------------------------------------------------------------------------- */
  function getPromoStorageKey() {
    var modal = document.getElementById('MannatWelcomeModal');
    var sig = modal ? (modal.getAttribute('data-promo-signature') || 'v1') : 'v1';
    return 'mannat_modal_dismissed_' + sig;
  }

  function markPromoDismissed() {
    try {
      sessionStorage.setItem(getPromoStorageKey(), 'true');
      sessionStorage.removeItem('mannat_welcome_modal_dismissed');
    } catch (e) {}
  }

  function initCopyButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-code]');
      if (!btn) return;
      e.preventDefault();

      var code = btn.getAttribute('data-copy-code');
      if (!code) return;

      markPromoDismissed();

      copyTextToClipboard(code).then(function () {
        var origHTML = btn.innerHTML;
        btn.classList.add('is-copied');
        btn.innerHTML = '<span>✓ COPIED</span>';

        var successNotice = document.getElementById('MannatCopySuccessNotice');
        if (successNotice) {
          successNotice.classList.add('is-active');
        }

        setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.innerHTML = origHTML;
          if (successNotice) {
            successNotice.classList.remove('is-active');
          }
        }, 3000);
      }).catch(function (err) {
        console.warn('Mannat Couture: Clipboard copy failed', err);
      });
    });

    // Also dismiss modal if user clicks the announcement reductions link
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.mannat-promo-bar__link');
      if (link) {
        markPromoDismissed();
      }
    });
  }

  /* -------------------------------------------------------------------------
   * 2. Luxury Welcome Privilege Modal
   * ------------------------------------------------------------------------- */
  function initWelcomeModal() {
    var modal = document.getElementById('MannatWelcomeModal');
    if (!modal) return;

    // Clean up legacy key
    try {
      sessionStorage.removeItem('mannat_welcome_modal_dismissed');
    } catch (e) {}

    var storageKey = getPromoStorageKey();

    // Do not show if visitor already dismissed this specific promotion in this session
    try {
      if (sessionStorage.getItem(storageKey) === 'true') {
        return;
      }
    } catch (e) {
      // storage disabled
    }

    var delayAttr = modal.getAttribute('data-modal-delay');
    var delay = delayAttr ? parseInt(delayAttr, 10) : 3000;

    function openModal() {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      // trigger CSS transition
      requestAnimationFrame(function () {
        modal.classList.add('is-visible');
      });
    }

    function closeModal() {
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      markPromoDismissed();

      setTimeout(function () {
        modal.classList.remove('is-active');
      }, 350);
    }

    // Timed launch
    setTimeout(openModal, delay);

    // Close handlers
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-visible')) {
        closeModal();
      }
    });
  }

  /* -------------------------------------------------------------------------
   * 3. Collection Discount Sorting ("Discount: High to Low")
   * ------------------------------------------------------------------------- */
  var isSorting = false;

  function sortProductGridByDiscount() {
    if (isSorting) return;
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    if (items.length <= 1) return;

    var sorted = items.slice().sort(function (a, b) {
      var cardA = a.querySelector('[data-discount-percentage]');
      var cardB = b.querySelector('[data-discount-percentage]');

      var discA = cardA ? parseFloat(cardA.getAttribute('data-discount-percentage')) || 0 : 0;
      var discB = cardB ? parseFloat(cardB.getAttribute('data-discount-percentage')) || 0 : 0;

      if (discB !== discA) {
        return discB - discA; // Highest discount % first
      }

      // Secondary sort: lower price first if discount % is equal
      var priceA = cardA ? parseFloat(cardA.getAttribute('data-product-price')) || 0 : 0;
      var priceB = cardB ? parseFloat(cardB.getAttribute('data-product-price')) || 0 : 0;
      return priceA - priceB;
    });

    // Check if items are already in correct order
    var alreadySorted = true;
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== sorted[i]) {
        alreadySorted = false;
        break;
      }
    }
    if (alreadySorted) return;

    isSorting = true;
    var frag = document.createDocumentFragment();
    sorted.forEach(function (item) {
      frag.appendChild(item);
    });
    grid.appendChild(frag);

    requestAnimationFrame(function () {
      isSorting = false;
    });
  }

  function syncSortDropdowns(val) {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      var hasOption = Array.from(sel.options).some(function (opt) {
        return opt.value === val;
      });
      if (hasOption && sel.value !== val) {
        sel.value = val;
      }
    });
  }

  function initDiscountSorting() {
    var u = new URL(window.location.href);
    var isDiscountSort = u.searchParams.get('sort_by') === 'discount-descending';

    if (isDiscountSort) {
      syncSortDropdowns('discount-descending');
      sortProductGridByDiscount();
    }

    // Intercept dropdown changes
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('select[name="sort_by"]');
      if (!sel) return;

      if (sel.value === 'discount-descending') {
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', 'discount-descending');
        window.history.replaceState({ path: currentUrl.toString() }, '', currentUrl.toString());
        syncSortDropdowns('discount-descending');
        sortProductGridByDiscount();
      }
    });

    // Observer for AJAX filter reloads (Dawn facet form updates)
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var observer = new MutationObserver(function (mutations) {
        if (isSorting) return;
        var currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('sort_by') === 'discount-descending') {
          // Only trigger if children of container or grid were modified by AJAX
          var isRelevant = mutations.some(function (m) {
            return m.type === 'childList' && (m.target === container || m.target.id === 'ProductGridContainer' || m.target.id === 'product-grid');
          });
          if (isRelevant) {
            syncSortDropdowns('discount-descending');
            sortProductGridByDiscount();
          }
        }
      });
      observer.observe(container, { childList: true });
    }
  }

  /* -------------------------------------------------------------------------
   * 4. Automatic Checkout Discount Code Integration
   * ------------------------------------------------------------------------- */
  function initAutoDiscountSync() {
    var promo = window.mannatPromoSettings;
    if (!promo || !promo.enabled || !promo.code) return;

    var code = promo.code.trim();
    if (!code) return;

    // Check if discount cookie is already set
    var hasCookie = document.cookie.split(';').some(function (c) {
      var parts = c.trim().split('=');
      return parts[0] === 'discount_code' && decodeURIComponent(parts[1] || '') === code;
    });

    if (!hasCookie) {
      // Pre-apply discount in Shopify session via /discount/ endpoint
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      }).catch(function () {});
    }

    // Ensure all forms submitting to /cart or /checkout include the discount input
    function ensureDiscountInputs() {
      document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
        var existing = form.querySelector('input[name="discount"]');
        if (!existing) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'discount';
          input.value = code;
          form.appendChild(input);
        } else if (!existing.value) {
          existing.value = code;
        }
      });
    }

    ensureDiscountInputs();
    document.addEventListener('shopify:section:load', ensureDiscountInputs);
  }

  /* -------------------------------------------------------------------------
   * Initialize on DOM Ready
   * ------------------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCopyButtons();
      initWelcomeModal();
      initDiscountSorting();
      initAutoDiscountSync();
    });
  } else {
    initCopyButtons();
    initWelcomeModal();
    initDiscountSorting();
    initAutoDiscountSync();
  }
})();
